import { useEffect, useRef } from "react";
import { motion } from "framer-motion";

export default function Intro({ onDone }) {
  const ref = useRef(null);
  const doneRef = useRef(false);

  useEffect(() => {
    const finish = () => {
      if (doneRef.current) return;
      doneRef.current = true;
      onDone();
    };
    const v = ref.current;
    if (v) {
      v.playbackRate = 1.35;
      v.play().catch(() => finish());
      const onTime = () => {
        if (v.currentTime >= 6.4) finish();
      };
      v.addEventListener("timeupdate", onTime);
      v.addEventListener("error", finish);
      const cap = setTimeout(finish, 8000);
      return () => {
        clearTimeout(cap);
        v.removeEventListener("timeupdate", onTime);
        v.removeEventListener("error", finish);
      };
    }
    const cap = setTimeout(finish, 2500);
    return () => clearTimeout(cap);
  }, [onDone]);

  return (
    <motion.div
      data-testid="intro-overlay"
      onClick={onDone}
      className="fixed inset-0 z-[100] flex cursor-pointer items-center justify-center bg-ivory"
      exit={{ opacity: 0, transition: { duration: 0.8, ease: "easeInOut" } }}
    >
      <video
        ref={ref}
        muted
        playsInline
        preload="auto"
        className="h-full w-full object-cover mix-blend-multiply"
      >
        <source src="/assets/verivista-signature-hd.webm" type="video/webm" />
        <source src="/assets/verivista-signature-hd.mp4" type="video/mp4" />
      </video>
      <p className="absolute bottom-10 font-mono text-[10px] uppercase tracking-[0.3em] text-bodylight/70">
        Tap to skip
      </p>
    </motion.div>
  );
}
